import {createContext, useContext} from 'react'

export type TableSize = 'small' | 'medium'

export interface TableContextValue {
  /** Row density. @default 'medium' */
  size: TableSize
  /** Pins the header row while the body scrolls (needs a height-bounded container). */
  stickyHeader: boolean
}

export const TableContext = createContext<TableContextValue>({
  size: 'medium',
  stickyHeader: false,
})

export function useTableContext(): TableContextValue {
  return useContext(TableContext)
}

/**
 * Which table section a cell lives in. Mirrors MUI's `Tablelvl2Context` — it lets
 * `TableCell` default its `variant` (and pick `<th>` vs `<td>`) from its parent
 * `TableHead` / `TableBody` / `TableFooter` instead of forcing the consumer to set it.
 */
export type TableSection = 'head' | 'body' | 'footer'

export const TableSectionContext = createContext<TableSection | null>(null)

export function useTableSection(): TableSection | null {
  return useContext(TableSectionContext)
}
